/**
 * Working-day date utilities for task due-date defaults.
 */

/**
 * Add N working days (Mon–Fri) to startDate, skipping Saturday and Sunday.
 */
export function addWorkingDays(startDate: Date, days: number): Date {
  const result = new Date(startDate)
  let added = 0
  while (added < days) {
    result.setDate(result.getDate() + 1)
    const dow = result.getDay()
    if (dow !== 0 && dow !== 6) added++
  }
  return result
}

/** Format a Date as YYYY-MM-DD for HTML date inputs. */
export function formatDateForInput(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

/** Default due date: 2 working days from today. */
export function getDefaultDueDate(): string {
  return formatDateForInput(addWorkingDays(new Date(), 2))
}

/** Today as YYYY-MM-DD. */
export function getTodayForInput(): string {
  return formatDateForInput(new Date())
}
